import { render, staticRenderFns } from "./addCodebook.vue?vue&type=template&id=6a51fe58&scoped=true&lang=html&"
import script from "./addCodebook.vue?vue&type=script&lang=js&"
export * from "./addCodebook.vue?vue&type=script&lang=js&"
import style0 from "./addCodebook.vue?vue&type=style&index=0&id=6a51fe58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a51fe58",
  null
  
)

export default component.exports